module.exports = __webpack_public_path__ + "img/broadcast-work-icon9.1fe6aedb.png";